import { Injectable } from '@angular/core';
import { getKDWBaseUrl } from '../helpers/kdw-base-url.helper';
import { OktaHttpReqService } from './okta-http-req.service';

@Injectable()
export class CtxFrequencyService {
  constructor(private okatHttpReqService: OktaHttpReqService) {}

  getCtxFrequencies(params) {
    const url = `${getKDWBaseUrl()}/api/v1/contextual/frequencies`;
    return this.okatHttpReqService.request('get', url, {params});
  }
}
